<app-screen-drawing-wrapper [drawingComponent]="drawingComponent" [pdfComponents]="pdfAssetComponents">
    <screen-drawing #drawingComponent></screen-drawing>
    <ng-content></ng-content>
</app-screen-drawing-wrapper>
